import 'react-app-polyfill/stable'

import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import * as Sentry from '@sentry/react'
import App, { mobileRoutes, desktopRoutes } from 'App'
import ja from 'date-fns/locale/ja'
import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'
import theme from 'themes/default'
import { isMobileBrowser } from 'utils/browsers'

const router = createBrowserRouter(isMobileBrowser() ? mobileRoutes : desktopRoutes)

const container = document.getElementById('root')
const root = createRoot(container)

if (import.meta.VITE_SENTRY_DSN && import.meta.VITE_SENTRY_RELEASE) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    release: import.meta.env.VITE_SENTRY_RELEASE,
  })
}

root.render(
  <StrictMode>
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App router={router} />
      </ThemeProvider>
    </LocalizationProvider>
  </StrictMode>,
)
